import * as Yup from 'yup'

/** Código do autenticador: seis dígitos, sem exceção. */
export const totpSchema = Yup.object().shape({
  codigo: Yup.string()
    .matches(/^\d{6}$/, 'O código tem 6 dígitos')
    .required('Código é obrigatório'),
})

/**
 * Código de recuperação: dez caracteres do alfabeto sem ambíguos, com ou sem o hífen que a
 * tela exibe. O backend normaliza da mesma forma, então colar com ou sem hífen funciona.
 */
export const codigoRecuperacaoSchema = Yup.object().shape({
  codigo: Yup.string()
    .transform((valor) => (valor ? valor.replace(/[\s-]/g, '').toUpperCase() : valor))
    .matches(/^[A-HJ-NP-Z2-9]{10}$/, 'Código de recuperação inválido')
    .required('Código é obrigatório'),
})
